/* * @Author: pz * @Date: 2019-11-27 09:26:18 * @Last Modified by: pz * @Last Modified time: 2019-11-27 09:26:18 */
/*不带搜索的Input组件 */
<template>
  <div :class="renderMainCls()" :style="`width:${width}`">
    <div class="before">
      <slot name="before"></slot>
    </div>
    <div class="input-box">
      <input
        class="labelSearchInput_input"
        :placeholder="placeholder"
        v-model="inputValue"
        @focus="focus"
        @blur="blur"
        @input="input"
      />
    </div>
  </div>
</template>
<script>
import classnames from 'classnames';
export default {
  props: {
    placeholder: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      inputValue: '',
      isFocus: false
    };
  },
  methods: {
    renderMainCls() {
      const { isFocus } = this;
      let cls = classnames({
        labelSearchInput: true,
        isFocus
      });
      return cls;
    },
    focus() {
      this.isFocus = true;
    },

    blur() {
      this.isFocus = false;
    },
    input() {
      const { inputValue } = this;
      this.$emit('input', inputValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.isFocus {
  border: 1px solid #1e8dff;
}
.labelSearchInput {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  position: relative;
  transition: all 200ms;
  outline: 0;
  height: 40px;
  display: flex;
  &:hover {
    border-color: #bdbdbd;
    transition: all 200ms;
  }
  &.isFocus {
    border-color: #1e8dff;
    &:hover {
      border-color: #1e8dff;
    }
  }
  .before {
    & > * {
      font-family: Helvetica;
      font-size: 14px;
      color: #707070;
      line-height: 40px;
      display: block;
      position: relative;
      cursor: default;
      padding-right: 12px;
      padding-left: 12px;
      &:after {
        content: '';
        position: absolute;
        width: 1px;
        background: #f2f2f2;
        height: 20px;
        right: 0;
        top: 10px;
      }
    }
  }
  .input-box {
    display: block;
    flex: 1;
    padding-left: 12px;
    padding-right: 12px;
    position: relative;
    .labelSearchInput_input {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      font-family: Helvetica;
      font-size: 14px;
      color: #333333;
      line-height: 14px;
    }
    .scrollbox {
      position: absolute;
      z-index: 5;
      width: 100%;
      left: 0px;
      top: 50px;
      box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
      border: 1px solid rgba(242, 242, 242, 1);
      &:after {
        content: ' ';
        border-width: 6px;
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        top: -6px;
        left: 15px;
        margin-left: -6px;
        border-top-width: 0;
        border-bottom-color: #fff;
      }
      ul {
        background: #fff;
        max-height: 220px;
        overflow: scroll;
        li {
          // height: 40px;
          padding: 8px 12px;
          color: #242424;
          letter-spacing: 0;
          cursor: pointer;
          font-size: 14px;
          &:hover {
            background: #fafafa;
          }
        }
        .scrollbox-item {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
